 <template>
 	<div>
 	<b-container class="share-tool mb-4 mt-4">
	  <b-row class="justify-content-md-center text-center">
	    <b-col><b-button block @click="ShareLinkedIn" variant="outline-primary"><i class="fa fa-linkedin"></i> LinkedIn</b-button></b-col>
	    <b-col><b-button block @click="ShareTwitter" variant="outline-primary"><i class="fa fa-twitter"></i> Twitter</b-button></b-col>
	  </b-row>
	  <b-row class="justify-content-md-center text-center mt-4">
	  	<!--<b-col><b-button block @click="ShareInstagram" variant="outline-primary" ><i class="fa fa-instagram"></i> Instagram</b-button></b-col>-->
      <b-col><b-button block @click="ShareReddit" variant="outline-primary" ><i class="fa fa-reddit"></i> Reddit</b-button></b-col>
	    <b-col><b-button block @click="ShareFacebook" variant="outline-primary"><i class="fa fa-facebook"></i> Facebook</b-button></b-col>
	  </b-row>
	  <b-row class="justify-content-md-center text-center mt-4">
	    <b-col><b-button block @click="ShareEmail" variant="outline-primary"><i class="fa fa-envelope"></i> Email</b-button></b-col>
	    <b-col><b-button block v-b-modal.share-mobile variant="outline-primary"><i class="fa fa-mobile"></i> SMS/WhatsApp</b-button></b-col>
	  </b-row>
	  <!-- <b-row class="mt-3">
	  	<b-col><b-button @click="ShareReddit" variant="outline-primary">Reddit <i class="fa fa-reddit"></i></b-button></b-col>
	  	<b-col><b-button @click="ShareWhatsApp" variant="outline-primary">WhatsApp <i class="fa fa-whatsapp"></i></b-button></b-col>
	    <b-col><b-button @click="ShareEmail" variant="outline-primary">Email <i class="fa fa-envelope"></i></b-button></b-col>
	    <b-col><b-button v-b-modal.share-sms variant="outline-primary">SMS <i class="fa fa-mobile"></i></b-button></b-col>
	  </b-row>-->

	</b-container>

  <b-modal id="share-twitter" title="Share via Twitter" size="lg">
    <b-embed type="iframe" aspect="16by9"
    :src="twitterLink"
    allowfullscreen></b-embed>
  </b-modal>

	<b-modal id="share-mobile" title="Share on Mobile" hide-footer>
		<b-row>
	    	<b-col><p>Scan the QR code below using your phone's camera and follow the link to open mobile sharing options: </p></b-col>
	    </b-row>
		<b-row>
	    	<b-col class="text-center">
				<qrcode-vue :value="mobile_share_link" size="280" level="H" />
			</b-col>
	  	</b-row>

	</b-modal>
	<b-modal id="share-sms" title="Share via SMS" size="lg">
		<b-row>
	    	<b-col><p>Fill out the recipient details and then scan the QR code with your phone to share SizzleDeck via SMS</p></b-col>
	    </b-row>
		<b-row>
	    	<b-col>
				<qrcode-vue :value="'sms:'+phonenumber+'&body='+message+' '+link.replace(/^https?:\/\//, '')" size="300" level="H" />
			</b-col>
			<b-col>

			  <b-input-group class="mb-3" prepend="Phone Number">
			    <b-form-input v-model="phonenumber"></b-form-input>
			  </b-input-group>
			  <b-input-group class="mb-3" prepend="Message">
			    <b-form-input v-model="message"></b-form-input>
			  </b-input-group>

			</b-col>
	  	</b-row>

	</b-modal>

	
	</div>
 </template>

<script>
import QrcodeVue from "qrcode.vue";

export default {
  components: {
      QrcodeVue,
  },

  props: {
    link: {
      type: String,
      default: '',
    },
    mobile_share_link: {
      type: String,
      default: '',
    },
    deckname: {
      type: String,
      default: '',
    },
    deckid: {
      type: String,
      default: '',
    }
    
  },

  data() {
    return {
      phonenumber: '+44',
      message: 'Check out our SizzleDeck',
      twitterLink: null,
    }
  },
  methods: {
      ShareLinkedIn: function(){

			var r = (Math.random() + 1).toString(36).substring(7);
			var link = this.link + '/share/'+r;
        	window.open("https://www.linkedin.com/sharing/share-offsite/?url="+link,'shareWindow',`width=400,height=640`);
        },
        ShareTwitter: function(){
        	
			 var vm = this;
       var r = (Math.random() + 1).toString(36).substring(7);
       var link = vm.link + '/share/'+r;
          	
          	
        let twitterLink = "https://twitter.com/share?text=" + vm.deckname + "&url=" + link +"&hashtags=SizzleDeck";
        
        //vm.$bvModal.show('share-twitter');
        

        //twitterWindow = window.open(twitterLink,'shareWindow',`width=600,height=680`);
        let twitterWindow = window.open(twitterLink,'shareWindow',`width=600,height=680`);
/*      
        twitterWindow.document.addEventListener('DOMContentLoaded', alert('meep'), true); 

        const url = `/deck/preshare`;
        axios.post(url,{'service':'twitter','deckid':vm.deckid,'r':r}).then(response => {
          //twitterWindow = window.close();
        });

*/
    
        

        },
        ShareInstagram: function(){
        	alert('ToDo');
        },
        ShareFacebook: function(){
        	var r = (Math.random() + 1).toString(36).substring(7);
			    var link = this.link + '/share/'+r;
        	window.open("https://www.facebook.com/sharer/sharer.php?u=" + link,'shareWindow',`width=560,height=750`);
        },
        ShareWhatsApp: function(){
        	window.open("https://api.whatsapp.com/send/?text=" + this.link +"&type=custom_url&app_absent=0",'shareWindow',`width=400,height=560`);
        },
        ShareReddit: function(){
        	window.open("http://www.reddit.com/submit?url=" + this.link,'shareWindow',`width=500,height=500`);
        },
        ShareEmail: function(){
        	window.open("mailto:?body=Check out our SizzleDeck: " + this.link,'_self');
        },
  },
  watch: {
    value(value) {

    },
  },

  mounted() {

  },

}
</script>

<style >


</style>
